"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _reactFiles = _interopRequireDefault(require("react-files")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _lodash2 = _interopRequireDefault(require("lodash.get")),
    _uiKit = require("@devsta/ui-kit"),
    _getValueFromGenericInput = require("@devsta/get-value-from-generic-input"),
    _clientAwsS = require("@devsta/client-aws-s3"),
    _Uploader = require("../../Uploader"),
    _UploadFiles = _interopRequireDefault(require("../containers/UploadFiles")),
    _VideoDetails = _interopRequireDefault(require("./VideoDetails"));

require("../styles/_post-details-form.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var PostDetailsForm = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.updateInputField = (0, _lodash["default"])(function (a) {
      return function (b) {
        var c = d.props.onFieldChange;
        c((0, _defineProperty2["default"])({}, a, "campaigns" === a ? b : (0, _getValueFromGenericInput.getStringValueFromGenericInput)(b)));
      };
    }), d.searchCampaigns = (0, _lodash["default"])((0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b,
          c,
          e,
          f,
          g,
          h,
          i,
          j,
          k,
          l,
          m = arguments;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return b = 0 < m.length && void 0 !== m[0] ? m[0] : "", c = d.props, e = c.getCampaigns, f = c.selectedOrganisationId, g = c.apolloClient, a.next = 4, e({
                organisationId: f,
                filter: {
                  searchTerm: b.toLowerCase()
                },
                limit: 4
              });

            case 4:
              if (h = a.sent, i = h.data, j = h.error, k = (0, _lodash2["default"])(i, "getCampaigns.campaigns") || (0, _lodash2["default"])(i, "getAllActiveCampaigns") || [], !j && k.length) {
                a.next = 10;
                break;
              }

              return a.abrupt("return", []);

            case 10:
              return a.next = 12, (0, _clientAwsS.replaceBucketKeysWithUrlsInArray)({
                apiClient: g,
                dataArray: k.map(function (a) {
                  return _objectSpread(_objectSpread({}, a), {}, {
                    organisationId: f
                  });
                }),
                substitutedKeys: ["coverImageKey"]
              });

            case 12:
              return l = a.sent, a.abrupt("return", l.map(d.getCampaignOption));

            case 14:
            case "end":
              return a.stop();
          }
        }
      }, a);
    }))), d.getCampaignOption = (0, _lodash["default"])(function (a) {
      if (!a) return null;
      var b = a.name,
          c = a.inspirationCampaignId,
          d = a.coverImageKey;
      return {
        label: b,
        value: c,
        prefix: _react["default"].createElement(_uiKit.Image, {
          imageUrl: d,
          placeholderText: b,
          placeholderTextSize: 12,
          defaultIconColour: "black",
          height: "25px",
          width: "25px"
        })
      };
    }), d.toggleModal = function () {
      d.setState(function (a) {
        var b = a.modalVisible;
        return {
          modalVisible: !b
        };
      });
    }, d.handleThumbnailChange = function () {
      var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
        var c, e;
        return _regenerator["default"].wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                c = d.props.onThumbnailChange, e = b[b.length - 1], c({
                  file: e,
                  previewUrl: e.preview.url
                });

              case 3:
              case "end":
                return a.stop();
            }
          }
        }, a);
      }));
      return function () {
        return a.apply(this, arguments);
      };
    }(), d.renderAttachVideo = function () {
      var a = d.props,
          b = a.assetId,
          c = a.onVideoAdd,
          e = a.post,
          f = a.selectedOrganisationId,
          g = d.state.modalVisible,
          h = e.assetId,
          i = e.embedCode,
          j = e.sourceLink,
          k = e.filename,
          l = e.organisationId;
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_uiKit.Text, {
        heading5: !0,
        required: !b
      }, b ? "Attached Video" : "Attach Video"), _react["default"].createElement("div", {
        className: "post-details-form__video-details"
      }, _react["default"].createElement(_Uploader.AssetSelector, {
        assetId: b || h
      }, function (a) {
        return _react["default"].createElement(_VideoDetails["default"], {
          title: a && a.filename || j || k || "Attach Videos to be used in your post",
          assetId: b || h,
          embedCode: i,
          updatedAt: b && a && a.updatedAt,
          showContentSource: !b
        });
      }), !b && !e.inspirationId && _react["default"].createElement(_uiKit.Button, {
        className: "post-details-form__video-details__upload-button",
        onClick: d.toggleModal
      }, "Upload Video")), !b && !e.inspirationId && _react["default"].createElement(_UploadFiles["default"], {
        modalVisible: g,
        toggleModal: d.toggleModal,
        onVideoAdd: c,
        postOrganisationId: l,
        selectedOrganisationId: f
      }));
    }, d.renderUploadThumbnail = function () {
      var a = d.props,
          b = a.post.thumbnailUrl,
          c = a.thumbnailUrl;
      return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_uiKit.Text, {
        heading5: !0
      }, "Attach Custom Thumbnail"), _react["default"].createElement("div", {
        className: "post-details-form__thumbnail"
      }, _react["default"].createElement(_uiKit.Image, {
        width: "75px",
        height: "75px",
        defaultImageIcon: "image",
        imageUrl: c || b,
        defaultIconColour: "russian",
        backgroundSize: "cover"
      }), _react["default"].createElement(_reactFiles["default"], {
        onChange: d.handleThumbnailChange,
        accepts: ["image/*", "*svg*"]
      }, _react["default"].createElement(_uiKit.Button, {
        className: "post-details-form__thumbnail__upload-button"
      }, "Upload Thumbnail"))));
    }, d.state = {
      modalVisible: !1
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.props,
          b = a.post,
          c = a.assetId,
          d = b.title,
          e = b.description,
          f = b.tagLine,
          g = b.referenceLink,
          h = b.assetId,
          i = b.embedCode,
          j = b.campaigns;
      return _react["default"].createElement("div", {
        className: "post-details-form"
      }, this.renderAttachVideo(), (c || h || i) && this.renderUploadThumbnail(), _react["default"].createElement("div", {
        className: "post-details-form__content"
      }, _react["default"].createElement(_uiKit.Text, {
        heading5: !0
      }, "Basic Details"), _react["default"].createElement("div", {
        className: "post-details-form__content__inner"
      }, _react["default"].createElement(_uiKit.Input, {
        id: "title-input",
        label: "Title",
        defaultValue: d,
        onChange: this.updateInputField("title"),
        placeholder: "Enter title",
        labelProps: {
          required: !0
        }
      }), _react["default"].createElement(_uiKit.Input, {
        id: "description-input",
        label: "Description",
        defaultValue: e,
        onChange: this.updateInputField("description"),
        placeholder: "Enter description",
        multiline: !0,
        labelProps: {
          required: !0
        }
      }), _react["default"].createElement(_uiKit.TagInput, {
        id: "tagLine-input",
        label: "Tags",
        defaultValue: f,
        onChange: this.updateInputField("tagLine"),
        placeholder: "Enter tags"
      }), _react["default"].createElement(_uiKit.Dropdown, {
        id: "select-campaign-input",
        label: "Campaign",
        placeholder: "Select Campaign",
        onChange: this.updateInputField("campaigns"),
        defaultValue: j && Array.isArray(j) ? j.map(this.getCampaignOption) : null,
        options: [],
        defaultOptions: !0,
        loadOptions: this.searchCampaigns,
        isClearable: !0,
        isSearchable: !0,
        multi: !0,
        type: "BUTTON"
      }), _react["default"].createElement(_uiKit.Input, {
        id: "reference-link-input",
        label: "Related Link",
        defaultValue: g,
        onChange: this.updateInputField("referenceLink"),
        placeholder: "Enter link"
      }))));
    }
  }]), b;
}(_react.Component);

exports["default"] = PostDetailsForm;